export const ticketStorageKeys = {
  // Stored in session storage
  residentFocusMode: () => `resident-focus`,
  filters: (slug: string) => `${slug}-ticket-filters` as const,
  portfolio_filters: () => `portfolio-ticket-filters`,
  // Stored in local storage
  tabSort: () => `tab-sorting`,
} as const;

export const TICKET_ASSIGNEE_UNASSIGNED_ID = "unassigned";

export function mapTicketAssigneeIdsToApi(ids?: string[]): string[] | undefined {
  return ids?.map((id) => (id === TICKET_ASSIGNEE_UNASSIGNED_ID ? "" : id));
}
